import React from 'react';

import * as S from './styles';
import { IconChevronDown } from '@prisjakt/ui/icon/chevron-down';
import { IconChevronUp } from '@prisjakt/ui/icon/chevron-up';

type VisibilityToggleProps = {
  onToggle: (value: boolean) => void;
  label: string;
  styling?: 'default' | 'small';
  active?: boolean;
  chip?: boolean;
};

const VisibilityToggle: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<VisibilityToggleProps>>
> = ({
  active = false,
  styling = 'default',
  onToggle,
  label,
  chip = false,
}) => (
  <S.ToggleVisibilityButton
    color="primary"
    chip={chip}
    size={styling === 'small' ? 'small' : 'medium'}
    variant={!active || styling === 'default' ? 'outlined' : 'default'}
    onClick={() => onToggle(!active)}
    icon={active ? <IconChevronUp /> : <IconChevronDown />}
    iconPosition="right"
  >
    {label}
  </S.ToggleVisibilityButton>
);

export default VisibilityToggle;
